/*Update Or Create Array By _id*/
import _ from "lodash";
Array.prototype.getOptions = function(labelField = 'name', valueField = '_id') {
    return this.map(o => {
        let label, value;

        if (typeof labelField == 'function') {
            label = labelField(o);
        } else {
            label = o[labelField];
        }

        if (typeof valueField == 'function') {
            value = valueField(o);
        } else {
            value = o[valueField];
        }
        return { label, value }
    });
}